<div
  *ngIf="isVisible"
  class="toast-notification"
  [ngClass]="{
    'toast-success': type === 'success',
    'toast-error': type === 'error',
    'toast-info': type === 'info',
    'toast-fade-out': isAnimatingOut
  }">

  <div class="toast-content">
    <div class="toast-icon">
      <i class="material-icons">{{ getToastIcon() }}</i>
    </div>

    <div class="toast-message">
      {{ message }}
    </div>

    <div class="toast-actions">
      <button
        *ngIf="action"
        class="toast-action-btn"
        (click)="onActionClick($event)"
        [ngClass]="'action-' + type">
        {{ action.label }}
      </button>

      <div *ngIf="dismissable" class="toast-close" (click)="onToastClick()">
        <i class="material-icons">close</i>
      </div>
    </div>
  </div>

  <div
    *ngIf="duration !== null"
    class="toast-progress-bar"
    #progressBar
    [ngClass]="'progress-' + type">
  </div>
</div>
